<p>
  testUpload works!
</p>


CON LIMITE

    <input type="file" #fileConLimite placeholder="Choose file" (change)="uploadFileConLimite(fileConLimite.files)" >
    <button type="button" (click)="fileConLimite.click()">Upload File </button>
   

SIN LIMITE

    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" >
    <button type="button" (click)="file.click()">Upload File </button>

    
    <span class="upload" *ngIf="progress > 0">
      {{progress}}%
    </span>
    <span class="upload" *ngIf="message">
      {{message}}
    </span>
    <div class="progress form-group" *ngIf="progress > 0">
      <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">
        {{progress}}%
      </div>
    </div>